<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m9.3 22-.4-3.2-.6-.3-.6-.4-3 1.3L2 14.6l2.6-2v-1.3L2 9.3l2.7-4.7 3 1.3 1.2-.7.4-3.2h5.4l.4 3.2.6.3.6.4 3-1.3L22 9.4l-2.6 2v1.3l2.6 2-2.8 4.7-2.9-1.3-1.2.7-.4 3.2zm1.7-2h2l.3-2.6a6 6 0 0 0 2.7-1.6l2.4 1 1-1.7-2.2-1.6.2-.7a6 6 0 0 0-.2-2.3l2.2-1.7-1-1.7L16 8.3a6 6 0 0 0-2.7-1.5L13 4h-2l-.3 2.7A6 6 0 0 0 8 8.2l-2.4-1-1 1.6 2.2 1.6-.2.8a6 6 0 0 0 .2 2.3l-2.2 1.7 1 1.7L8 15.8a6 6 0 0 0 2.7 1.6zm1-4.5q1.5 0 2.5-1t1-2.5-1-2.5-2.5-1-2.4 1-1 2.5 1 2.5 2.4 1"
    />
  </svg>
</template>
